<template>
  <VDropdown
    :placement
    :triggers="['hover', 'focus']"
    :popperTriggers="['hover']"
    :delay="{ show: 0, hide: closeDelay }"
    :distance="8"
    theme="dropdown"
  >
    <slot name="trigger" />
    <template #popper>
      <slot name="content" />
    </template>
  </VDropdown>
</template>

<script setup lang="ts">
// Hover-triggered card with rich slotted content, backed by Floating Vue (Floating UI under the
// hood) for auto flip/shift positioning. popperTriggers:['hover'] keeps it open when the pointer
// moves from the trigger into the card.
import { Dropdown as VDropdown } from 'floating-vue';

withDefaults(
  defineProps<{
    /** Which side of the trigger the card opens toward (auto-flips when there's no room). */
    placement?: 'top' | 'bottom' | 'left' | 'right';
    /** Delay before hiding after the pointer leaves, in ms. Lets the mouse cross into the card. */
    closeDelay?: number;
  }>(),
  { placement: 'top', closeDelay: 120 },
);
</script>
